// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth, hasRol } from "context/AuthContext";
import { useDelegaciones } from "modules/pedidos/hooks/useDelegaciones";

// `allowIfDelegado` (opcional): { rol, flag } — deja pasar además a quien tenga
// `rol` cuando la delegación `flag` (config/app.delegaciones) está activa.
// Ej: la facturación deja entrar a "ventas" si delegaciones.ventasFactura === true.
export default function ProtectedRoute({ roles, allowIfDelegado }) {
  const { user, profile, loading } = useAuth();
  const deleg = useDelegaciones();

  if (loading) {
    return <div style={{ padding: 20 }}>Cargando sesión…</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Multi-rol: el usuario pasa si tiene ALGUNO de los roles requeridos
  // (soporta profile.roles array — ej. Marcela: obras + administracion).
  const okRoles = !roles || roles.length === 0 || hasRol(profile, ...roles);
  const okDeleg = allowIfDelegado && hasRol(profile, allowIfDelegado.rol) && !!deleg?.[allowIfDelegado.flag];
  if (!okRoles && !okDeleg) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
